import { RouteObject } from "react-router";
import { Lazy } from "@shared/components/ui/lazy";

import { useAppName } from "@shared/hooks/useAppName";

const Login = Lazy(() => import("@shared/features/auth/pages/login"), "Login");
const OauthCallback = Lazy(() => import("@shared/features/auth/pages/oauth-callback"), "OauthCallback");
const OauthLogoutCallback = Lazy(() => import("@shared/features/auth/pages/oauth-logout-callback"), "OauthLogoutCallback");
const PendingActivation = Lazy(() => import("@shared/features/newUser/pages/pending-activation"), "PendingActivation");
const NewUser = Lazy(() => import("@shared/features/newUser/pages/new-user"), "NewUser");

export interface AuthRoutesProps {
  onlyLogin?: boolean;
}

export const getAuthRoutes = (props: AuthRoutesProps = {}): RouteObject[] => {
  const { onlyLogin } = props;
  const { isMobilityCare, isNatalConnect, isMobilityCareAfrica } = useAppName();

  if (onlyLogin) {
    return [{ path: "login", element: <Login /> }];
  }

  const authRoutes: RouteObject[] = [
    { path: "login", element: <Login /> },
    {
      path: "register",
      children: [
        { index: true, element: <Login register /> },
        ...(isMobilityCare || isNatalConnect || isMobilityCareAfrica
          ? [
              { path: "select", element: <Login register="select" /> },
              { path: "patient", element: <Login register="patient" /> },
              { path: "doctor", element: <Login register="doctor" /> },
              {
                path: "organization",
                element: <Login register="organization" />,
              },
              {
                path: "organizationManager",
                element: <Login register="organizationManager" />,
              },
            ]
          : []),
        ...(isMobilityCare || isMobilityCareAfrica
          ? [{ path: "assistant", element: <Login register="assistant" /> }]
          : []),
        ...(isNatalConnect
          ? [{ path: "midwife", element: <Login register="midwife" /> }]
          : []),
      ],
    },
    { path: "new-user", element: <NewUser /> },
  ];

  if (isMobilityCare || isNatalConnect || isMobilityCareAfrica) {
    authRoutes.push(
      { path: "oauth", element: <OauthCallback /> },
      { path: "oauth/psc", element: <OauthCallback /> },
      { path: "oauth/psc/logout", element: <OauthLogoutCallback /> },
      { path: "pending-activation", element: <PendingActivation /> }
    );
  }

  return authRoutes;
};
